export const CUSTOM_ICONS = [
  'account_balance_wallet',
  'admin_panel_settings',
  'advanced_analytics',
  'alpha_creation',
  'analytic_models',
  'asset_dynamics',
  'asset_optimization',
  'asset_sourcing',
  'asset_tokenization',
  'automated_operations',
  'automation_scale',
  'borrower_behavior',
  'cash_flow_engine',
  'chart_pie_slice',
  'cloud',
  'dashboard',
  'data_aggregation',
  'data_drives_decisions',
  'data_info_alert',
  'data_ingestion_extraction',
  'data_pipelines',
  'data_science_intelligence',
  'data_sourcing',
  'data_validations',
  'democratizing_access',
  'detection',
  'diversity_3',
  'doc_management',
  'documents',
  'donut_large',
  'due_diligence',
  'encrypted',
  'environment_social_government',
  'etl_visualization',
  'event_seat',
  'failed_big',
  'file_copy',
  'ftp',
  'grading',
  'housing_value',
  'hub',
  'identify',
  'insights',
  'inventory',
  'investor_requirements',
  'line_end_square',
  'line_start_square',
  'liquidity',
  'loader_animation',
  'loader',
  'loan',
  'location_city',
  'long_term',
  'machine_learning',
  'macro_micro_economic_indications',
  'manage_accounts',
  'manage',
  'manufacturing',
  'mapping-connection',
  'markdown_paste',
  'medium_term',
  'mitigation',
  'mixture_model',
  'monetization',
  'monitoring',
  'ocr_nlp',
  'operational_efficiency',
  'portability_and_tradability',
  'predictability',
  'prevention',
  'pricing_strategy',
  'probate_refferals',
  'problem',
  'propensity_model',
  'quality_control',
  'quantify',
  'real_estate_agent',
  'relativity',
  'results_output',
  'search_insights',
  'search',
  'sftp',
  'success_big',
  'supply_demand',
  'swap_horiz',
  'third_party_data_file',
  'today',
  'transaction_management',
  'transparency',
  'trending_up',
  'unknown_med',
  'validity',
  'workflow'
];
